export const LANGUAGES_ARRAY = [
  "en",
  "ru",
  "es",
  "pt",
  "ms",
  "vi",
  "fr",
  "de",
  "ar",
  "id",
  "th",
  "ko",
  "ja",
  "nl",
  "it",
  "sv",
  "uk",
  "zh",
  "he",
  "hi",
  "tl",
  "cs",
  "pl",
  "no",
  "tr",
  "da",
  "jw",
  "ur",
];

export const LARGE_TRANSLATIONS = [
  "de",
  "ru",
  "fr",
  "uk",
  "it",
  "es",
  "ms",
  "id",
  "nl",
];

export const CREATE_PAGE_PATH = "/page/create";
